<template>
    <img 
        v-lazy="src"
        :title="title"
        :style = "imgStyle"
        :class="className"
        :alt="alt"
        :id="id"
        />
</template>

<script>
export default {
    name: 'Thumbnail',
    computed: {
        src(){
            return this.data.thumbnails && this.data.thumbnails[this.size] || this.data.image
        }
    },
    props: {
        data: {
            type: Object,
        },
        imgStyle: {
            type: String
        },
        size: {
            type: String
        },
        className: {
            type: String
        },
        title: {
            type: String
        },
        alt: {
            type: String
        },
        id: {
            type: String
        }
    },
}
</script>

<style lang="scss" scoped>

</style>